export default class Scale {
  constructor() {
    this.order = Infinity;
    this.forceScale = this.forceScale.bind(this);
    this.checkScrollCollission = this.checkScrollCollission.bind(this);
    this.preScale = this.preScale.bind(this);
    this.postScale = this.postScale.bind(this);
    this.scale = this.scale.bind(this);
  }

  run($$1) {
    this.$$ = $$1;
    const {
      $$,
    } = this;
    $$.baseScale = 1;
    $$.minScale = 1;
    $$.maxScale = 1;

    $$.scale = this.scale;

    $$.$.on("seats:rendered", this.forceScale);

    return $(window).on("orientationchange resize", this.forceScale);
  }

  forceScale() {
    return this.preScale().scale(1).postScale();
  }

  checkScrollCollission() {
    const {
      $$,
    } = this;

    const halfWrapper = $($$.wrapper).width() / 2;
    const halfWrapperWidth = ~~($($$.wrapper).width() / 2);
    const halfWrapperHeight = ~~($(".arena-workspace").height() / 2);
    const halfCanvasPlaceholderWidth = ~~($$.sectionOuterWidth / 2);
    const halfCanvasPlaceholderHeight = ~~($$.sectionOuterHeight / 2);
    const halfCanvasWidth = ~~(($$.sectionOuterWidth * $$.realScale) / 2);
    const halfCanvasHeight = ~~(($$.sectionOuterHeight * $$.realScale) / 2);
    const arenaWorkspaceEl = $(".arena-workspace")[0];
    const baseScrollLeft = ($$.sectionOuterWidth - $($$.wrapper).width()) / 2;
    const baseScrollTop = ($$.sectionOuterHeight - $(".arena-workspace").height()) / 2;
    const sectionHeight = $$.sectionOuterHeight * $$.baseScale;

    // Left collision
    if (arenaWorkspaceEl.scrollLeft < (halfCanvasPlaceholderWidth - halfCanvasWidth)) {
      arenaWorkspaceEl.scrollLeft = halfCanvasPlaceholderWidth - halfCanvasWidth;
    }

    // Right collision
    if (arenaWorkspaceEl.scrollLeft > (((halfCanvasPlaceholderWidth - halfWrapperWidth) + halfCanvasWidth) - halfWrapperWidth)) {
      arenaWorkspaceEl.scrollLeft = ((halfCanvasPlaceholderWidth - halfWrapperWidth) + halfCanvasWidth) - halfWrapperWidth;
    }

    // if (arenaWorkspaceEl.scrollTop > (halfCanvasPlaceholderHeight - halfCanvasHeight) and (halfCanvasPlaceholderHeight - halfCanvasHeight) > 0)
    //   arenaWorkspaceEl.scrollTop = halfCanvasPlaceholderHeight - halfCanvasHeight

    // if (arenaWorkspaceEl.scrollTop < halfCanvasPlaceholderHeight - halfWrapperHeight + halfCanvasHeight - halfWrapperHeight)
    //   arenaWorkspaceEl.scrollTop = halfCanvasPlaceholderHeight - halfWrapperHeight + halfCanvasHeight - halfWrapperHeight
    return this;
  }

  preScale() {
    const {
      $$,
    } = this;
    let $scene = $$.$arena.prev(".scene");
    if ($scene.length === 0) {
      $scene = $$.$arena.next(".scene");
    }

    $$.sectionOuterWidth = ($$.SEAT_WIDTH * 2) + $$.seatsWidth + $$.standSeatsWidth;
    $$.sectionOuterHeight = ($$.SEAT_HEIGHT * 2) + $$.seatsHeight + $$.standSeatsHeight + $scene.height();

    $$.baseScale = $($$.wrapper).width() / (($$.SEAT_WIDTH * 2) + $$.seatsWidth + $$.standSeatsWidth);
    $$.baseScale = $$.baseScale > 1 ? 1 : $$.baseScale;
    $$.maxScale = (1 / $$.baseScale);

    $(".arena-workspace")
      .off("scroll mousewheel DOMMouseScroll", this.checkScrollCollission)
      .on("scroll mousewheel DOMMouseScroll", this.checkScrollCollission);

    $(".arena-canvas-placeholder").css({
      width: $$.sectionOuterWidth,
      height: $$.sectionOuterHeight,
    });

    $(".arena-canvas").css({
      width: $$.sectionOuterWidth,
      height: $$.sectionOuterHeight,
    });
    return this;
  }

  postScale() {
    const {
      $$,
    } = this;
    // Center scrollbars
    $(".arena-workspace")[0].scrollLeft = (($$.sectionOuterWidth - $($$.wrapper).width()) / 2);
    // $(".arena-workspace")[0].scrollTop = (($$.sectionOuterHeight - $(".arena-workspace").height()) / 2);
    return this;
  }

  scale(scale) {
    const {
      $$,
    } = this;
    $$.currentScale = scale < $$.minScale ?
      $$.minScale :
      scale > $$.maxScale ?
      $$.maxScale :
      scale;
    $$.realScale = $$.baseScale * $$.currentScale;
    $(".arena-canvas").css({
      transform: `scale(${$$.realScale})`,
      transformOrigin: "top center",
    });
    this.checkScrollCollission();
    return this;
  }
}

window.SectionScale = Scale;
